import React from "react";
import "./CoinColumn.scss";
export function CoinColumn({player}) {
    return <div className={"coin-column"}>
        {Array(14).fill(null).map((_,i)=><div key={i} className={"coin "+(((14-i)>player.coins)?"disabled":"")}></div>)}
    </div>;
}